import type { RootState } from '@/redux/store'

type InvitingClient = { id: number | string }

const NO_CLIENTS: InvitingClient[] = []

/**
 * The clients whose invitations are pending, straight from the store.
 *
 * Read this rather than calling `useInvites` again: every call of that hook
 * subscribes to the websocket and refetches on each event. The account button in
 * the top bar, which is on every page, already calls it and keeps the store
 * current. The slice holds an object rather than a list until the first response,
 * or after an error — hence the check.
 */
export const selectInvitingClients = (state: RootState): InvitingClient[] => {
  const { data } = state.collaboration.inviting
  return Array.isArray(data) ? data : NO_CLIENTS
}
